import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { Router } from '@angular/router'
import { User } from '@core/data'
import { CoinsBadge } from '@shared/components'

@Component({
  selector: 'user-profile-badge',
  imports: [CoinsBadge],
  templateUrl: './user-profile-badge.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'bg-primary-900 shadow-primary-inset ml-auto flex min-w-0 flex-row items-center gap-2 rounded-full px-1.5 py-1.5 pr-3 cursor-pointer',
    '(click)': 'goToProfile()'
  }
})
export class UserProfileBadge {
  #router = inject(Router)
  user = input.required<User>()

  goToProfile() {
    this.#router.navigate(['/profile'])
  }
}
